import { createSlice } from "@reduxjs/toolkit";
import { data } from "../../data/requiredPhotoData";
import { MobilePhotoAction } from "../../data/MobilePhotoAction";

export const imageUploadSlice = createSlice({
  name: "imageUploads",
  initialState: {
    images: [],
    requiredPhotoData: data,
    currentImageIdentifiers: [],
    currentUploads: [],
    maxUploads: 10,
    currentUploadHelper: null,
    error: false,
    uploadValidationError: null,
    mobileImageLastAction: MobilePhotoAction.NONE,
    mobileDeviceWithCamera: false,
    mobilePhotoUploadChoiceMade: false
  },
  reducers: {
    setRequiredPhotoData: (state, action) => {
      const isIncluded = state.requiredPhotoData.some(
        (data) =>
          parseInt(data.questionId) === parseInt(action.payload.questionId)
      );
      if (isIncluded) {
        state.requiredPhotoData = state.requiredPhotoData
          .map((data) =>
            parseInt(data.questionId) === parseInt(action.payload.questionId)
              ? action.payload
              : data
          )
          .sort((a, b) => a.order - b.order);
      } else {
        state.requiredPhotoData = [
          ...state.requiredPhotoData,
          action.payload
        ].sort((a, b) => a.order - b.order);
      }
    },
    removeRequiredPhotoData: (state, action) => {
      state.requiredPhotoData = state.requiredPhotoData.filter(
        (data) => parseInt(data.questionId) !== parseInt(action.payload)
      );
    },
    clearUnSavedImages: (state, action) => {
      const savedIds = action.payload.map((image) => image.imageIdentifier);
      state.images = state.images.filter((image) =>
        savedIds.includes(image.imageIdentifier)
      );
    },
    clearCurrentImageIdentifiers: (state) => {
      state.currentImageIdentifiers = [];
    },
    clearCurrentUploads: (state) => {
      state.currentUploads = [];
    },
    setMaxUploads: (state, action) => {
      state.maxUploads = action.payload;
    },
    setCurrentUploadHelper: (state, action) => {
      state.currentUploadHelper = action.payload;
    },
    clearImages: (state) => {
      state.images = [];
    },
    setImages: (state, action) => {
      const isIncluded = state.images.some(
        (image) => image.imageSrc === action.payload.imageSrc
      );
      if (isIncluded) {
        state.images = state.images.map((image) => {
          if (image.imageSrc === action.payload.imageSrc) {
            return {
              ...image,
              progress: action.payload.progress,
              imageIdentifier: action.payload.imageIdentifier
            };
          } else {
            return image;
          }
        });
      } else {
        state.images = [...state.images, action.payload];
      }
    },
    setCurrentUploads: (state, action) => {
      state.currentUploads = [
        ...new Set([...state.currentUploads, action.payload])
      ];
    },
    setRetryingRequest: (state, action) => {
      state.retrying = action.payload;
    },
    setCurrentImageIdentifiers: (state, action) => {
      state.currentImageIdentifiers = [
        ...state.currentImageIdentifiers,
        action.payload
      ];
    },
    setUploadError: (state, action) => {
      state.error = action.payload;
    },
    removeUnsuccessfulImages: (state) => {
      state.images = state.images.filter((image) => image.imageIdentifier);
    },
    removeCurrentImageIdentifier: (state, action) => {
      state.currentImageIdentifiers = state.currentImageIdentifiers.filter(
        (identifier) => identifier !== action.payload
      );
    },
    deleteImage: (state, action) => {
      state.images = state.images.filter(
        (image) =>
          image.imageSrc !== action.payload.imageSrc ||
          image.imageIdentifier !== action.payload.imageIdentifier
      );
      state.currentUploads = state.currentUploads.filter(
        (image) => image !== action.payload.imageSrc
      );
    },
    flagImageForDeletion: (state, action) => {
      state.images = state.images.map((image) =>
        image.imageIdentifier === action.payload.image.imageIdentifier
          ? {
              ...image,
              flaggedForDeletion: action.payload.flaggedForDeletion,
              extraImage: action.payload.extraImage
            }
          : image
      );
    },
    resetFlagImageForDeletion: (state, action) => {
      state.images = state.images.map((image) =>
        true
          ? {
              ...image,
              flaggedForDeletion: false
            }
          : {
              ...image,
              flaggedForDeletion: false
            }
      );
    },

    setMobileImageLastAction: (state, action) => {
      state.mobileImageLastAction = action.payload;
    },

    setMobilePhotoUploadChoiceMade: (state, action) => {
      state.mobilePhotoUploadChoiceMade = action.payload;
    },

    setMobileDeviceWithCamera: (state, action) => {
      state.mobileDeviceWithCamera = action.payload;
    },

    setReturnToGallery: (state, action) => {
      state.returnToGallery = action.payload;
    },
    setImagesWithoutBlobs: (state, action) => {
      state.images = action.payload;
    },
    setGalleryAccordionOpen: (state) => {
      state.galleryAccordionOpen = true;
    },
    setUploadValidationError: (state, action) => {
      state.uploadValidationError = action.payload;
    },
    clearUploadValidationError: (state) => {
      state.uploadValidationError = null;
    }
  }
});
